module.exports = __webpack_public_path__ + "static/media/notes-of-love-eight.f7d65f42.png";